import { useAppDispatch } from '@/store/hooks'
import { setDocumentTitle, setMainSlug, setMainTitle, setPageTitle, setSubTitle } from '@/store/slices/uiSlice'
import { useEffect } from 'react'

const useDocumentTitle = (titleKey: string, mainTitle?: string | undefined | null, mainSlug?: string | undefined | null, subTitle?: string | undefined | null) => {
    const dispatch = useAppDispatch()

    useEffect(() => {
        const translatedTitle = titleKey
        dispatch(setPageTitle(translatedTitle))
        dispatch(setDocumentTitle(translatedTitle))
        if (mainTitle && mainTitle) {
            dispatch(setMainTitle(mainTitle))
            dispatch(setMainSlug(mainSlug))
        }

        if (subTitle) {
            dispatch(setSubTitle(subTitle))
        }
    }, [dispatch, titleKey, mainTitle, mainSlug])
}

export default useDocumentTitle
